import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Page from 'ui/page'
import { Card, CardHeader, CardBody, Collapse } from 'reactstrap'
import parse from 'react-html-parser'
import cn from 'classnames'

const FaqItem = ({ title, content }) => {
  const [active, setActive] = useState(false)

  return (
    <Card className="mb-3 border-0 shadow-sm">
      <CardHeader
        onClick={() => setActive(!active)}
        className="bg-light d-flex justify-content-between align-items-center"
        style={{ cursor: 'pointer' }}
      >
        <h5 className="m-0">{title}</h5>
        <i className={cn('fa', active ? 'fa-caret-up' : 'fa-caret-down')} />
      </CardHeader>

      <Collapse isOpen={active}>
        <CardBody>{parse(content)}</CardBody>
      </Collapse>
    </Card>
  )
}

const Faq = (props) => {
  const { records } = props
  const { i18n } = useTranslation()

  return (
    <Page {...props}>
      <h1 className="mb-4">{i18n.t('faq.title')}</h1>

      <div className="accordion" id="faqAccordion">
        {records.map((item) => (
          <FaqItem key={item.id} {...item} />
        ))}
      </div>
    </Page>
  )
}

export default Faq